import * as React from "react";
import classnames from "classnames";
import envConfig from "../../utils/env-config";

export const EnvNavBarTag: React.FC = () => {
  return envTagValue ? (
    <div className={"navbar-item"}>
      <EnvTag />
    </div>
  ) : null;
};

export const EnvTag: React.FC = () => {
  return envTagValue ? (
    <span
      className={classnames(
        "tag",
        envTagValue.color,
        "is-large",
        "has-text-weight-bold",
      )}
    >
      {envTagValue.status}
    </span>
  ) : null;
};

export const envTagValue: { status: string; color: string } | undefined =
  envConfig.matchEnvValue({
    dev: { status: "DEVELOPMENT environment", color: "is-info" },
    local: { status: "Local", color: "is-light" },
    production: undefined,
    production_sandbox: { status: "サンドボックス", color: "is-info" },
    staging: { status: "STAGING environment", color: "is-success" },
    staging_sandbox: {
      status: "STAGING (サンドボックス)",
      color: "is-success",
    },
  });
